import {
  ORDER_MODEL_KEY,
  ORDER_MODEL_STATUS
} from 'models/daos/order/constants/index.cjs'
import getValueReduxUtil from 'modules/redux/utils/get-value'

function getStatusOrderUtil (instance) {
  return getValueReduxUtil(instance, ORDER_MODEL_KEY.STATUS)
}

function isInPreparationOrderUtil (instance) {
  return getStatusOrderUtil(instance) === ORDER_MODEL_STATUS.PREPARATION
}

export {
  isInPreparationOrderUtil
}
